import type { ReactNode } from 'react'

import { IFrame } from '../components/index'

// In ZD articles, it is possible that we have empty <p> tags. Do not render them.
export function isChildrenEmpty(children?: ReactNode) {
    if (!children) {
        return true
    }

    if (Array.isArray(children)) {
        return !children.some((child) => {
            if (child === null || child === '') {
                return false
            }
            if (typeof child === 'string' && child.trim() === '') {
                return false
            }
            return true
        })
    }

    return false
}

// ZenDesk wraps `<iframes>` with `<p>` elements that will cause hydration errors
// The child component can be either a single react node or an array of elements
// Here we are checking if the child component or possible grand children are
// iframes and ensuring that the `<p>` tag is not rendered
export function isChildrenContainsIframe(children?: ReactNode) {
    if (!children) {
        return false
    }

    try {
        if (Array.isArray(children)) {
            for (let i = 0; i < children.length; i++) {
                const child = children[i]

                if (Array.isArray(child)) {
                    for (let j = 0; j < child.length; j++) {
                        const c = child[j]
                        if (c && c.type === IFrame) {
                            return true
                        }
                    }
                } else {
                    if (child?.type && child.type === IFrame) {
                        return true
                    }
                }
            }
        }
    } catch (e) {
        return false
    }
    return false
}
